import TomSelect from 'tom-select';

export class MapDropwdown
{
	constructor ( $container )
	{
		this.$container = $container;

		this.$seasonSwitcher = this.$container.querySelector( '.season-selector.inside-map .seasons-dropdown' );

		if ( this.$seasonSwitcher.length < 1 )
		{
			console.error( '[MapToggler] This just isn\'t going to work out. Missing season selectors.' );
			return;
		}

		this.activeSeason  = 0;
		this.highestSeason = this.getHighestSeason();

		const $selectedOption = this.$seasonSwitcher.querySelector( 'option:checked' );
		if ( $selectedOption )
		{
			const selectSeason = $selectedOption.dataset.season;
			if ( selectSeason )
			{
				this.activeSeason = selectSeason;
			}
		}

		this.$seasonMaps = this.$container.querySelectorAll( '.season-map' );

		this.isHeroMode = this.areWeInHero();

		this.$maybeSectionTitle = document.querySelector( '.section_title.map' );

		this.setupPrettyDropdown();

		this.bindEvents();
	}

	bindEvents ()
	{
		this.$seasonSwitcher.addEventListener( 'change', ( event ) =>
		{
			const $selectedOption = this.$seasonSwitcher.querySelector('option:checked');
			const selectedSeason = parseInt($selectedOption.dataset.season);

			this.adjustSeason( selectedSeason );
		} );
	}

	getHighestSeason ()
	{
		let allSeasons = Array.from( this.$seasonSwitcher.querySelectorAll( 'option' ) ).map( option => parseInt( option.dataset.season ) );
		allSeasons.sort();

		this.allSeasons = allSeasons;

		return allSeasons.pop();

	}

	areWeInHero ()
	{

		const $parentHeroContainer = this.$container.closest( '.episode-list-hero' );

		return $parentHeroContainer !== null;
	}


	setupPrettyDropdown ()
	{
		// https://tom-select.js.org/docs/#controlinput

		this.dropdownSettings     = {
			controlInput : false,
		}
		this.prettySelectInstance = new TomSelect( this.$seasonSwitcher, this.dropdownSettings );
	}


	adjustSeason ( wantedSeason )
	{


		for ( let i = 0; i <= this.highestSeason; i++ )
		{

			if ( i !== wantedSeason )
			{
				this.$container.classList.remove( 'active-season-' + i );

				if ( this.$maybeSectionTitle )
				{
					this.$maybeSectionTitle.classList.remove( 'active-season-' + i );
				}
			}

		}

		this.$seasonMaps.forEach(map => {
			if(parseInt(map.dataset.season ) === wantedSeason) {
				map.classList.add('active');
			}  else {
				map.classList.remove('active');
			}
		})

		this.$container.classList.add( 'active-season-' + wantedSeason );
		if ( this.$maybeSectionTitle )
		{
			this.$maybeSectionTitle.classList.add( 'active-season-' + wantedSeason );
		}

		this.activeSeason = wantedSeason;

		console.log('Adjusted for season ' + this.activeSeason)
	}
}


const $allMaps = document.querySelectorAll( '.content_block_map' );

if ( $allMaps.length > 0 )
{
	$allMaps.forEach( ( el, i ) =>
	{
		const mapDropdown = new MapDropwdown( el );
	} );
}